var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 930.909091c-230.981818 0-418.909091-187.927273-418.909091-418.909091S281.018182 93.090909 512 93.090909s418.909091 187.927273 418.909091 418.909091-187.927273 418.909091-418.909091 418.909091m0-907.636364C242.082909 23.272727 23.272727 242.082909 23.272727 512s218.810182 488.727273 488.727273 488.727273 488.727273-218.810182 488.727273-488.727273S781.917091 23.272727 512 23.272727m0 267.636364a34.909091 34.909091 0 0 0-34.909091 34.909091v277.248a34.909091 34.909091 0 1 0 69.818182 0V325.818182a34.909091 34.909091 0 0 0-34.909091-34.909091m0 393.099636c-19.269818 0-34.909091 13.591273-34.909091 30.370909 0 16.756364 15.639273 30.347636 34.909091 30.347637s34.909091-13.591273 34.909091-30.347637c0-16.756364-15.639273-30.370909-34.909091-30.370909",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.16d6b25311460276b1de8bc0825ff80e.svg";
export { ForwardRef as ReactComponent };